import { Modal, Typography } from '@/shared/ui';
import { motion } from 'framer-motion';
import React from 'react';
import motorbike from '../../../public/images/profile/motorbike.png';
import styles from './TechnicalModal.module.scss';

interface TechnicalModalProps {
	onClick: () => void;
	subtitle: string;
	textButton: string;
	title: string;
	onClose?: () => void;
}

const TechnicalModal = ({ onClick, title, subtitle, textButton, onClose }: TechnicalModalProps) => {
	return (
		<motion.div
			className={styles.referalContainer}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
		>
			<div className={styles.overlay} />
			<div className={styles.wrapper}>
				<Modal isLight textButton={textButton.toUpperCase()} dismissOnClick={onClose} onClick={onClick}>
					<div className={styles.content}>
						<img src={motorbike} className={styles.motorbike} alt='motorbike' />
						<Typography variant='title1' color='white'>
							{title}
						</Typography>
						<Typography variant='body2' style={{ color: 'white', opacity: 0.7 }}>
							{subtitle}
						</Typography>
					</div>
				</Modal>
			</div>
		</motion.div>
	);
};

export default TechnicalModal;
